module.exports = __webpack_public_path__ + "static/peppers-giftcard-7a01b3eac243f98d8bba0874f7d9d8ac.jpg";